/** Whether a route path is one of the admin pages, the surface under the `/admin` route record. */
export function isAdminPath(path: string): boolean {
  return path.startsWith("/admin");
}
